import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './stores/userSlice';
import localUserReducer from './stores/localUserSlice';
import orgReducer from './stores/orgSlice';
import storage from 'redux-persist/lib/storage';
import { CookieStorage } from 'redux-persist-cookie-storage'
import Cookies from 'cookies-js'
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const rootPersistConfig = {
  key: 'root',
  blacklist: ['user', 'localUser', 'org'],
  storage,
}
  
const userCookieStorage = new CookieStorage(Cookies, {
  expiration: {
    'default': 8 * 3600
  }
});

// 'orgs' carries each org's full nav/modules/activityTypes JSON and can easily
// exceed the ~4KB per-cookie browser limit, causing the whole cookie write to be
// silently dropped. Keep it out of the cookie and persist it via localStorage instead.
const ORGS_STORAGE_KEY = 'user_v2_orgs';

const userStorage = {
  getItem: async (key) => {
    const [cookieRaw, orgsRaw] = await Promise.all([
      userCookieStorage.getItem(key),
      storage.getItem(ORGS_STORAGE_KEY)
    ]);

    if (!cookieRaw) return cookieRaw;

    let parsed;
    try {
      parsed = JSON.parse(cookieRaw);
    } catch (e) {
      return cookieRaw;
    }

    if (orgsRaw !== null && orgsRaw !== undefined) {
      parsed.orgs = orgsRaw;
    }

    return JSON.stringify(parsed);
  },
  setItem: async (key, value) => {
    let parsed;
    try {
      parsed = JSON.parse(value);
    } catch (e) {
      return userCookieStorage.setItem(key, value);
    }

    const orgs = parsed.orgs;
    delete parsed.orgs;

    await storage.setItem(ORGS_STORAGE_KEY, orgs);
    return userCookieStorage.setItem(key, JSON.stringify(parsed));
  },
  removeItem: async (key) => {
    await storage.removeItem(ORGS_STORAGE_KEY);
    return userCookieStorage.removeItem(key);
  }
};

const userPersistConfig = {
  key: 'user_v2',
  storage: userStorage,
}

const localUserPersistConfig = {
  key: 'localUser_v2',
  storage: storage,
}

const orgPersistConfig = {
  key: 'org_v2',
  storage
}

const rootReducer = combineReducers({ 
  user: persistReducer(userPersistConfig, userReducer), // login only for 10 minutes, saved in sessions
  localUser: persistReducer(localUserPersistConfig, localUserReducer),
  org: persistReducer(orgPersistConfig, orgReducer)
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
})

export const persistor = persistStore(store);